<template>
  <div style="height:100%;">
    <van-nav-bar
      title="抽奖活动"
      left-text=""
      left-arrow
      @click-left="onClickLeft()">
    </van-nav-bar>
    <van-notice-bar left-icon="volume-o" :scrollable="false" style="height:25px;">
      <van-swipe vertical class="notice-swipe" :autoplay="1500" :show-indicators="false">
        <van-swipe-item v-for="(item,index) in luckyerList" :key="index">{{item}}</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <div class="dial">
      <div style="text-align:right;margin-top:1%;margin-right:5px;">
        <van-tag mark type="danger" size="large" @click="toDrawLog()">抽奖记录</van-tag>
      </div>
      <div style="margin-top:2%;text-align:center;font-weight:bold;">
        <van-tag type="danger" size="large" style="font-size:15px;">
          您还有{{remaindrawChance}}次抽奖机会，再做{{remainNum}}单可获得抽奖一次
        </van-tag>
      </div>
      <div style="text-align:center;">
        <img src="../../assets/draw2024/title_bg.png" style="width:100%;margin-top:2%;" />
      </div>
      <!-- 转盘包裹 -->
      <div class="rotate">
        <!-- 转盘图片 -->
        <img class="dish" src="../../assets/draw2024/dial3.png" :style="{transform:rotate_deg,transition:rotate_transition}" />
        <!-- 指针图片 -->
        <img class="pointer" src="../../assets/draw2024/click.png" @click="start" />
      </div>
    </div>
  </div>
  
</template>
<script>
import { Image, NavBar, NoticeBar, Swipe, SwipeItem, Tag, Toast } from "vant";
import { showToast } from 'vant'
import AppVue from "../../App.vue";
var light_timer; //灯光定时器
export default {
  name: "dial",
  data() {
    return {
      // LuckyClick: 3,
      circleList: [], //原点设置
      colorCircleFirst: "#FE4D32", //圆点颜色
      colorCircleSecond: "#fff", //圆点颜色
 
      cat: 60, //总共6个扇形区域，每个区域约60度
      isAllowClick: true, //是否能够点击
      rotate_deg: 0, //指针旋转的角度
      rotate_transition: "transform 3s ease-in-out", //初始化选中的过度属性控制
      remaindrawChance: 0,
      remainNum : 0,
      luckyerList: [],
    };
  },
  created() {
    this.showcircleList();
    this.GetData();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    //绘制圆点设置
    showcircleList() {
      let circleList = [];
      for (var i = 0; i < 16; i++) {
        circleList.push(i);
      }
      this.circleList = circleList;
      this.light();
    },
 
    //闪动效果
    light: function() {
      var that = this;
      clearInterval(light_timer);
      light_timer = setInterval(function() {
        if (that.colorCircleFirst == "#FE4D32") {
          that.colorCircleFirst = "#fff";
          that.colorCircleSecond = "#FE4D32";
        } else {
          that.colorCircleFirst = "#FE4D32";
          that.colorCircleSecond = "#fff";
        }
      }, 300); //设置圆点闪烁的效果
    },
 
    start() {
      // if (this.remaindrawChance == 0) {
      //   alert("机会已经用完了");
      //   return;
      // }
      this.rotating();
    },
 
    rotating() {
      if (!this.isAllowClick) return;
      this.isAllowClick = false;
      this.rotate_transition = "transform 3s ease-in-out";
      // this.remaindrawChance--;
      // var rand_circle = 5; //默认多旋转5圈

      this.$http
        .get("SDWorker/LuckyDraw2024?period=1", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") {
            this.remaindrawChance--;
            var rand_circle = 5; //默认多旋转5圈

            console.log(res.data.Data);
            var winningIndex = res.data.Data;
            console.log(winningIndex);
            var randomDeg = 360 - winningIndex*60+60; //当前下标对应的角度    60是总共6个扇形区域，每个区域约60度 （指针停留在奖品中间）
      
            var deg = rand_circle * 360 + randomDeg; //将要旋转的度数  由于是顺时针的转动方向需要用360度来减
            this.rotate_deg = "rotate(" + deg + "deg)";
      
            var that = this;
            setTimeout(function() {
              that.isAllowClick = true;
              that.rotate_deg = "rotate(" + 0 + "deg)"; //定时器关闭的时候重置角度
              that.rotate_transition = "";

              if (winningIndex == 1) {
                that.$toast("恭喜您，获得28.8元积分红包一个");
              } else if (winningIndex == 2) {
                that.$toast("恭喜您，获得电热水壶一个，请填写收货地址，填写后请耐心等待奖品配送！");
              } else if (winningIndex == 3) {
                that.$toast("恭喜您，获得天力文化衫一件，请填写收货地址并选择尺码，填写后请耐心等待奖品配送！");
              } else if (winningIndex == 4) {
                that.$toast("恭喜您，获得数显热熔机一台，请填写收货地址，填写后请耐心等待奖品配送！");
              } else if (winningIndex == 5) {
                that.$toast("恭喜您，获得腮网前置一个，请填写收货地址，填写后请耐心等待奖品配送！");
              } else if (winningIndex == 6) {
                that.$toast("恭喜您，获得2024元积分红包一个");
              }
            }, 3500);

          } else {
            console.log(res.data);
            this.$toast(res.data);
          }
        });
    },
    toDrawLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "LuckDrawRecord2024",
        params: {},
      });
    },
    GetData() {
      var that = this;
      that.$http.get("SDWorker/GetLuckyer2024?period=1").then((res) => {
        that.luckyerList = res.data.ListData;
      });
      that.$http.get("SDWorker/GetDrawChance2024?period=1").then((res) => {
        that.remaindrawChance = res.data.Data.RemainChance;
        that.remainNum = res.data.Data.RemainNum;
      });
    },
     onClickLeft() {
      this.$router.back(-1);
    },
 
    //设置概率
    set() {
      var winIndex;
      //方法2
      var __rand__ = Math.random();
      if (__rand__ < 0.3) winIndex = 2;
      else if (__rand__ < 0.6) winIndex = 1;
      else if (__rand__ < 0.99) winIndex = 4;
      else if (__rand__ < 0.92) winIndex = 3;
      else if (__rand__ == 0.99) winIndex = 0;
 
      return winIndex;
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>
<style scoped>
.dial{
  height: 100%;
  width: 100%;
  position: relative;
  background-image: url('../../assets/draw2024/draw_bg.jpg');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: contain;
}
.times {
  text-align: center;
  line-height: 1.8rem;
  background: #fff;
}
.rotate {
  width: 21.1rem;
  height: 21.1rem;
  /* background: #ffbe04; */
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
}
 
.rotate .dish {
  width: 22rem;
  height: 22rem;
}
 
.pointer {
  width: 10.25rem;
  height: 12.65rem;
  position: absolute;
  top: 36%;
  left: 50.5%;
  transform: translate(-50%, -50%);
}
 
.prize {
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  z-index: 100;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

</style>